import { isString, isUndefined } from "ramda-adjunct";
import { iconMapper } from "./Icons.mapper";
import { IconType } from "./Icons.types";
import svgIconContents from "../../import-icons";

interface IconProps {
  kind: IconType;
  color?: string;
  width?: number;
  height?: number;
  onClick?: (kind: IconType) => void;
}

export const IconRT: React.FC<IconProps> = ({
  color = "black",
  kind,
  width = "32px",
  height = "32px",
  ...rest
}) => {
  const builder = iconMapper.get(kind);
  if (isUndefined(builder)) {
    return <>{kind} icon not found</>;
  }
  const { onClick } = rest;

  const IconComponent = builder as any;
  return (
    <IconComponent style={{ color: color, width, height }} onClick={onClick} />
  );
};
